

















import { Component } from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import { StaffNotificationSubscriptionDto } from '@/asdcom/apiproxy/apiproxy.dto';

@Component({})
export default class Settings extends BaseComponent {
  settingList: StaffNotificationSubscriptionDto[] = [];

  async created() {
    this.settingList = await this.$appsvs.vcpOnlineOkStaff.retrieveSubscribedNotifications()
  }

  async submitNotificationSubscription(item: StaffNotificationSubscriptionDto): Promise<void> {
    this.$appsvs.vcpOnlineOkStaff.subscribeToNotification(item);
  }
}
